import { Component, OnInit, DebugElement } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserModel } from 'src/app/model/UserModel';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { KeyValuePair } from 'src/app/model/RenewPlan';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-dashboard-menu',
  templateUrl: './dashboard-menu.component.html',
  styleUrls: ['./dashboard-menu.component.css']
})
export class DashboardMenuComponent implements OnInit {
  contactVisible = false;
  currentUser : UserModel;
  showCustomerMenu:boolean = true;
   contactForm: FormGroup;
  selectedValue: string;
  sitekey:string ="6LcFR7kUAAAAAJWUVN6uFlOu9L6dn-EZGAWuDquf";

  showKycmenu: boolean=false;

  
  optionList:any[];

  constructor(private authenticationService: AuthenticationService, private formBuilder: FormBuilder, private sharedService:SharedService) {
    this.optionList =this. sharedService.getSupportOptions();
    this.currentUser = this.authenticationService.getCurrentUser();

    if(this.currentUser)
    {
      if(this.currentUser.i_Account != "0")
      {
      
        this.showCustomerMenu = false;
        this.showKycmenu = false;
  
   
      }

      if(this.currentUser.i_Account == "0")
      {
      
    
        this.showKycmenu = true;
  
   
      }


    }


   


   }

 
   resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }
  ngOnInit() {
    this.contactForm = this.formBuilder.group({
      recaptcha: ['', Validators.required]
    });
  }


  openContact(): void {
    this.contactVisible = true;
  }

  close(): void {
    this.contactVisible = false;
  }
}
